// extracted by mini-css-extract-plugin
module.exports = {"centerChat":"_34NKO","leftChat":"_3MZfz","chatCon":"_2gPFv","loading":"VRiyA","fakeImportBtn":"_2_Q9y","saveBtn":"fkGZE"};